// extracted by mini-css-extract-plugin
export var mt0 = "fp-_r";
export var mt1 = "fp--r";
export var mt2 = "fp-0r";
export var mt3 = "fp-1r";
export var mt4 = "fp-2r";
export var mt5 = "fp-3r";
export var mt6 = "fp-4r";
export var widgetBreadcrumbs = "fp-5r";
export var widgetBreadcrumbs__icon = "fp-6r";
export var widgetBreadcrumbs__link = "fp-7r";